// TODO: Max classes  1file = 1 class
import * as React from "react";
import { BootstrapTable, ButtonGroup, TableHeaderColumn } from "react-bootstrap-table";
import * as Modal from "react-modal";
import { filter, isEmpty, isUndefined } from "lodash";
import { Button } from "react-bootstrap";

import { clearNonNumberCharacters, Component, getRandomKey } from "../../helpers/Utils";

import { Field, Option } from "./types";
import Select from "./Select";

import "react-bootstrap-table/dist/react-bootstrap-table.min.css";

interface Props {
	fields: Array<Field>;
	values: Array<any>;
	disabled: boolean;
	onChange: <A, B, C>(a: A, b?: B, c?: C) => void;
	onUpdate: <T>(args: T[]) => void;
}

interface IGridState {
	selectRow: object;
}

interface ModalEditorState {
	open: boolean;
	value: object;
}

interface ModalEditorProps {
	title: string;
	columns: Array<Field>;
	cells: object;
	onSave: (row: object) => void;
}

interface EditorModalTableProps {
	columns: Array<Field>;
	onSave: (row: object) => void;
	onModalClose: () => void;
	title: string;
	value?: object;
}

interface EditorModalTableState {
	validateState: { [key: string]: string };
	value: { [key: string]: any };
	selectDisabled: boolean;
}

class EditorModalTable extends React.Component<EditorModalTableProps, EditorModalTableState> {
	state = {
		validateState: {},
		value: {},
		selectDisabled: false,
	};

	constructor(props) {
		super(props);

		this.setState({
			validateState: {},
			value: props.value
				? { ...props.value, service: { label: props.value.service, value: props.selectKey } }
				: { key: `key_${getRandomKey()}` },
			selectDisabled: !isEmpty(props.value),
		});
	}

	validateMaxNumber = (rows: any, outValidate: any) => {
		const prop = this.props.columns.find((t) => t.key === "service" && t.type === "select");
		if (prop) {
			const option = prop.options.find((t) => t.key === rows.service);
			if (option && option.max && parseFloat(rows.price) > option.max) {
				outValidate.price = `Больше максимального числа: ${option.max}`;
			}
		}
	};

	onClick = () => {
		const rows = this.state.value;
		const validateState = {};
		this.props.columns.forEach((column: Field) => {
			if (!column.isKey) {
				const value = this.state.value[column.key];
				if (column.require && isEmpty(value)) validateState[column.key] = "Обязательное поле для заполнения";
			} else if (!isUndefined(this.props.value)) rows[column.key] = this.props.value[column.key];
		}, this);
		this.validateMaxNumber(rows, validateState);

		this.setState({ validateState });
		if (isEmpty(validateState)) {
			this.props.onSave(rows);
			this.props.onModalClose();
		}
	};

	onChangeSelect = ({ target: { value: _value, name } }) => {
		this.setState(({ value }) => ({
			value: {
				...value,
				[name]: { ..._value },
			},
		}));
	};

	onChangeInput = ({ target: { value: _value, name } }) => {
		this.setState(({ value }) => ({
			value: {
				...value,
				[name]: _value,
			},
		}));
	};

	onNumberChange: any = ({ target: { value: _value, name } }) => {
		this.setState(({ value }) => ({
			value: {
				...value,
				[name]: clearNonNumberCharacters(_value),
			},
		}));
	};

	createControl(field: Field) {
		let control = null;
		switch (field.type) {
			case "select":
				control = (
					<Select
						name={field.key}
						disabled={this.state.selectDisabled}
						onChange={this.onChangeSelect}
						options={field.options}
						value={this.state.value[field.key]}
					/>
				);
				break;
			case "textarea":
				control = (
					<textarea
						name={field.key}
						onChange={this.onChangeInput}
						maxLength={2000}
						value={this.state.value[field.key] || ""}
						className="form-control"
						rows={5}
					/>
				);
				break;
			case "number":
				control = (
					<input
						name={field.key}
						inputMode="decimal"
						onChange={this.onNumberChange}
						className="form-control"
						value={this.state.value[field.key] || ""}
						type="text"
						onInput={this.onNumberChange}
						min={0}
					/>
				);
				break;
			default:
				break;
		}
		return (
			<div className="form-group" key={field.key}>
				<label className={field.require ? "required" : ""}>{field.name}</label>
				{control}
				{this.state.validateState[field.key] && (
					<span className="label label-danger">{this.state.validateState[field.key]}</span>
				)}
			</div>
		);
	}

	render() {
		return (
			<div className="modal-content react-bs-table-insert-modal">
				<div className="modal-header ">
					<button type="button" className="close" onClick={this.props.onModalClose}>
						<span aria-hidden="true">×</span>
					</button>
					<h4 className="modal-title">{this.props.title}</h4>
				</div>
				<div className="modal-body">
					{this.props.columns.filter((field: Field) => !field.isKey).map((field: Field) => this.createControl(field))}
				</div>
				<div className="modal-footer">
					<button type="button" className="btn btn-default btn-secondary" onClick={this.props.onModalClose}>
						Отмена
					</button>
					<button type="button" className="btn btn-primary" onClick={this.onClick}>
						Сохранить
					</button>
				</div>
			</div>
		);
	}
}

class ModalEditor extends React.Component<ModalEditorProps, ModalEditorState> {
	state = {
		open: false,
		value: null,
	};

	onShow = (value) => {
		this.setState({ open: true, value });
	};

	render() {
		const closeModal = () => this.setState({ open: false });
		return (// @ts-ignore
			<Modal
				isOpen={this.state.open}
				className="react-bs-insert-modal modal-dialog"
				contentLabel="Modal"
				ariaHideApp={false}
			>
				<EditorModalTable
					title="Редактировать"
					value={this.state.value}
					onModalClose={closeModal}
					columns={this.props.columns}
					onSave={this.props.onSave}
				/>
			</Modal>
		);
	}
}

class Table extends Component<Props, IGridState> {
	private modal: ModalEditor;

	state = {
		selectRow: {},
	};

	// eslint-disable-next-line react/no-unused-class-component-methods
	onClick = () => {
		if (!isEmpty(this.state.selectRow)) {
			this.modal.onShow(null);
		}
	};

	onEdit = () => {
		if (!isEmpty(this.state.selectRow)) {
			this.modal.onShow(this.state.selectRow);
		}
	};

	onCreateRow = (row: any) => {
		const selected = this.props.fields.find((f: Field) => f.type === "select");
		if (selected) {
			const option = selected.options.find((opt: Option) => opt.key === row[selected.key].value);
			this.props.onChange([...this.props.values, { ...row, [selected.key]: option.value.ru, selectKey: option.key }]);
		} else {
			this.props.onChange([...this.props.values, row], row, true);
		}
	};

	onChangeRow = (row: any) => {
		const selected = this.props.fields.find((f: Field) => f.type === "select");
		const index = this.props.values.findIndex((t) => t.key === row.key);

		if (index > -1) {
			const tempValues = [...this.props.values];
			const option = selected.options.find((opt: Option) => opt.key === row.selectKey);
			tempValues[index] = { ...row, [selected.key]: option.value.ru, selectKey: option.key };

			this.props.onUpdate([...tempValues]);
		}
	};

	onDelete = () => {
		if (!isEmpty(this.state.selectRow)) {
			const fieldKey = this.getFieldKey();
			const values = filter(this.props.values, (o: object) => o[fieldKey] !== this.state.selectRow[fieldKey]);

			this.props.onChange(values, this.state.selectRow, false);
		}
	};

	getFieldKey = () => {
		const field = this.props.fields.find((col: Field) => col.isKey);
		return field.key;
	};

	render() {
		const config = {
			insertRow: !this.props.disabled,
			deleteRow: !this.props.disabled,
			height: "210px",

			selectRow: {
				mode: "radio",
				bgColor: "#ddd",
				hideSelectColumn: true,
				clickToSelect: true,
				onSelect: (row, isSelected: boolean, _e) => this.setState({ selectRow: isSelected ? row : {} }),
			},
			options: {
				insertText: "Добавить статью расхода в текущий блок",
				noDataText: "Нет данных для отображения",

				deleteBtn: () => (// @ts-ignore
					<Button onClick={this.onDelete} bsStyle="danger">
						<span className="fa fa-trash" />
						Удалить статью расхода
					</Button>
				),

				btnGroup: (props) => (
					<ButtonGroup>
						{props.insertBtn}
						{props.deleteBtn}
						{/*// @ts-ignore*/}
						<Button bsStyle="success" onClick={this.onEdit}>
							<span className="fa fa-endit" />
							Редактировать
						</Button>
					</ButtonGroup>
				),

				insertModal: (onModalClose) => (
					<EditorModalTable
						title="Добавить статью расхода"
						onModalClose={onModalClose}
						columns={this.props.fields}
						onSave={this.onCreateRow}
					/>
				),
			},
		};
		const customCell = (cell) => (
			<span style={{ whiteSpace: "normal" }} title={cell}>
				{cell}
			</span>
		);
		const width = { price: "200px", comment: "550px" };
		return (
			<div>
				<BootstrapTable {...config} data={this.props.values} bodyContainerClass="react-bs-container-body_v1">
					{this.props.fields.map((column: Field, idx: number) => (
						<TableHeaderColumn
							isKey={column.isKey}
							width={["price", "comment"].indexOf(column.key) > -1 ? width[column.key] : undefined}
							hidden={column.isKey}
							thStyle={{ whiteSpace: "normal" }}
							dataFormat={customCell}
							key={idx}
							dataField={column.key}
						>
							{column.name}
						</TableHeaderColumn>
					))}
				</BootstrapTable>
				<ModalEditor
					ref={(modal) => {
						this.modal = modal;
					}}
					title="Редактировать"
					columns={this.props.fields}
					onSave={this.onChangeRow}
					cells={this.state.selectRow}
				/>
			</div>
		);
	}
}
export default Table;
